import {deferrablePost} from '../../../assets/javascripts/offline_handler';

export default function() {
    $('body').off('click', '.star-holder');
    $('body').on('click', '.star-holder', function() {
        let tag = {category: $(this).attr('data-category'), value: $(this).attr('data-name')}
        let route = $(this).hasClass('selected') ? '/remove_favourite_tag' : '/add_favourite_tag'
        deferrablePost(route, {tag: JSON.stringify(tag)});
        $(this).toggleClass('selected');
        $(this).closest('.tag-panel').remove();
    })
}
